import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

const SITE = "Il Cassetto delle Giraffe di Fabio Campana";

export default function Privacy() {
  return (
    <div className="relative z-10">
      <Header />
      <article className="max-w-3xl mx-auto px-6 md:px-8 pt-16 md:pt-24 pb-10" data-testid="privacy-page">
        <p className="label-ui text-[#9F583F] mb-5">Note legali</p>
        <h1 className="font-display text-5xl md:text-6xl leading-[1] tracking-tight text-[#1C1917]">
          Privacy Policy
        </h1>
        <div className="article-body mt-10 font-body text-lg leading-loose text-[#292524] space-y-5">
          <p>
            La presente informativa descrive come vengono trattati i dati personali degli utenti che
            visitano <strong>{SITE}</strong>, in conformità al Regolamento UE 2016/679 (GDPR).
          </p>

          <h2 className="font-display text-3xl text-[#1C1917] pt-6">1. Titolare del trattamento</h2>
          <p>
            Il titolare del trattamento è Fabio Campana, contattabile tramite la pagina Contatti del sito.
          </p>

          <h2 className="font-display text-3xl text-[#1C1917] pt-6">2. Dati raccolti</h2>
          <p>
            Raccogliamo i dati che fornisci volontariamente: <strong>nome e cognome ed email</strong> quando
            lasci un commento; <strong>nome, email, azienda e messaggio</strong> quando utilizzi il modulo di
            contatto. Possono inoltre essere raccolti dati tecnici anonimi (es. conteggio delle letture).
          </p>

          <h2 className="font-display text-3xl text-[#1C1917] pt-6">3. Finalità del trattamento</h2>
          <p>
            I dati vengono utilizzati esclusivamente per: pubblicare e gestire i commenti; rispondere alle
            richieste inviate tramite il modulo di contatto; migliorare l'esperienza di lettura. L'email
            fornita nei commenti <strong>non viene pubblicata</strong>.
          </p>

          <h2 className="font-display text-3xl text-[#1C1917] pt-6">4. Base giuridica</h2>
          <p>
            Il trattamento si fonda sul consenso dell'utente, prestato al momento dell'invio spontaneo dei
            dati (commento o messaggio).
          </p>

          <h2 className="font-display text-3xl text-[#1C1917] pt-6">5. Conservazione</h2>
          <p>
            I dati sono conservati per il tempo necessario alle finalità indicate e comunque non oltre
            quanto previsto dalla normativa vigente.
          </p>

          <h2 className="font-display text-3xl text-[#1C1917] pt-6">6. Diritti dell'utente</h2>
          <p>
            Hai diritto di accedere, rettificare, cancellare i tuoi dati e di opporti al loro trattamento.
            Per esercitare questi diritti è sufficiente scriverci tramite la pagina Contatti.
          </p>

          <h2 className="font-display text-3xl text-[#1C1917] pt-6">7. Cookie</h2>
          <p>
            Il sito utilizza esclusivamente cookie tecnici necessari al funzionamento. Non vengono
            utilizzati cookie di profilazione a fini pubblicitari.
          </p>

          <p className="text-[#57534E] italic pt-6">
            Ultimo aggiornamento: {new Date().toLocaleDateString("it-IT", { month: "long", year: "numeric" })}.
          </p>
        </div>
      </article>
      <Footer />
    </div>
  );
}
